<svg
  [attr.viewBox]="getViewBoxString$() | async"
  [class.round-container]="isInsideZoomPanel"
  preserveAspectRatio="xMidYMid meet"
>
  <foreignObject
    [attr.width]="(imageSize$ | async)![0]"
    [attr.height]="(imageSize$ | async)![1]"
  >
    <div xmlns="http://www.w3.org/1999/xhtml">
      <!-- Only allow projection rendering if container size is set -->
      <h3-scene-canvas
        *ngIf="containerSize$ | async"
        [viewRegionNames]="[videoOutputName]"
        [size]="imageSize$ | async"
      ></h3-scene-canvas>
    </div>
  </foreignObject>
</svg>
